export default __webpack_public_path__ + "static/media/avatar_xiao_mei5.12306c73.mp3";